<template>
  <div class="box1">
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> -->
      <div class="additionalInformation" v-for="(item,index) in dataList" :key="index">
        <div class="information">
          <div class="callType">
            <div class="title">通话类型</div>
            <div class="details">{{item.type}}</div>
          </div>
          <div class="callingNumber">
            <div class="title">主叫号码</div>
            <div class="details">{{item.drivingNumber}}</div>
          </div>
          <div class="calledNumber">
            <div class="title">被叫号码</div>
            <div class="details">{{item.passiveNumber}}</div>
          </div>
          <div class="callDetails">
            <div class="title">通话详情</div>
            <div class="details">{{item.content}}</div>
          </div>
        </div>
      </div>
    <!-- </van-list> -->
      <isNoInfo :isNolist='isNolist'></isNoInfo>
    <!-- <scroll-bottom></scroll-bottom> -->
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../components/isNoInfo'
    import scrollBottom from './scrollBottom'
    import util from '../../../../utils/common'
    export default {
        components: {
            isNoInfo,
            'scroll-bottom': scrollBottom
        },
        data () {
            return {
                item: util.getJsonLocal('item'), 
                curPage: 1,
                pageSize: 10,
                dataList: [],
                loading: false,
                finished: false,
                isNolist: false
            }
        },
        created () {
            this.handList()
        },
        methods: {
            handList () {
                let parms = {
                    data:{
                      mainComplainNumber: this.item.mainComplainNumber,
                      type: 'callRecordsDetails',
                      curPage: this.curPage,
                      pageSize: this.pageSize
                    }
                    
                };
                api.worker.detailInfo(parms).then(res => {
                    if (res.ret === 0) {
                        if (res.data) {
                            if (res.data.virtualNumberDetails.callRecordList) {
                                if (res.data.virtualNumberDetails.callRecordList.length > 0) {
                                    this.dataList = res.data.virtualNumberDetails.callRecordList;
                                } else {
                                    this.isNolist = true
                                }
                            } else {
                                this.isNolist = true
                            }
                        } else {
                            this.isNolist = true
                        }
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
.box1 {
  position: relative;
  left: 0;
  top: 0;
  z-index: 2;
  padding: 0 12px 12px 12px;
  background-color: #fbfbfb;
  box-sizing: border-box;
  min-height: 6.2rem;
  .additionalInformation {
    margin: 0 0 24px 0;
    width: 100%;
    background-color: #fff;
    padding: 16px;
    .information {
      width: 100%;
      font-size: 14px;
      .callType,
      .callingAgency,
      .callingNumber,
      .calledNumber,
      .callDetails {
        display: flex;
        .title {
          width: 70px;
          color: #999999;
        }
        .details {
          color: #333333;
          margin-left: 12px;
          span {
            float: left;
          }
          img {
            display: inline-block;
            width: 15px;
            margin-top: -2px;
            margin-left: 5px;
          }
        }
      }
      .callingAgency,
      .callingNumber,
      .calledNumber,
      .callDetails {
        margin-top: 12px;
      }
    }
    .content {
      width: 100%;
      font-size: 14px;
      color: #333333;
      font-weight: Regular;
      margin-top: 12px;
    }
  }
  /deep/.main {
      .box1{
          margin-top: 100px;
      }
  }
}
</style>
